var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFile = function SvgFile(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 59.29 46"
  }, props), _path || (_path = React.createElement("path", {
    fill: "currentColor",
    d: "M27.23 6L22 0H0v38.32A7.68 7.68 0 007.68 46h43.98a7.65 7.65 0 007.63-7.63V6zM3.73 3.73h16.54l5.28 6h30v5.87H11.62v22.72a3.93 3.93 0 01-3.45 3.9 4.52 4.52 0 01-4.44-4.51v-34zm50.69 37.4a3.91 3.91 0 01-2.76 1.14H14.25a7.64 7.64 0 001.1-3.91v-19h40.21v19a3.91 3.91 0 01-1.14 2.77zm-7.16-10.52a2.49 2.49 0 11-2.48-2.49 2.48 2.48 0 012.48 2.49zm-8.76 0a2.49 2.49 0 11-2.5-2.49 2.49 2.49 0 012.5 2.49zm-8.77 0a2.49 2.49 0 11-2.48-2.49 2.48 2.48 0 012.48 2.49z",
    "data-name": "Layer 2"
  })));
};
export default __webpack_public_path__ + "1cb63954097556239c7011dfaa4c80c5.svg";
export { SvgFile as ReactComponent };